// iter317 — Divisions belong to a Trade. Role/extra scopes use division KEYS meaning
// "this division in every allowed Trade", so key pickers dedupe by key.
export const uniqueDivisionKeys = (divs = []) => {
  const seen = new Map();
  divs.forEach((d) => { if (!seen.has(d.key)) seen.set(d.key, { key: d.key, name: d.name }); });
  return [...seen.values()];
};

export const divisionsForTrade = (divs = [], tradeId) => (tradeId ? divs.filter((d) => d.trade_id === tradeId) : uniqueDivisionKeys(divs));
